/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/**
 * EDS breakpoints
 * value         |0px     768px    1024px    1280px   1440px   1920px
 * key           |xs      sm       md       lg       xl       xxl
 * screen width  |--------|--------|--------|--------|---------|----------->
 * range         |   xs   |   sm   |   md   |   lg   |   xl    |   xxl
 */
export const breakpoints = {
	xxs: 0,
	xs: 375,
	sm: 768,
	md: 1024,
	lg: 1280,
	xl: 1440,
	xxl: 1920,
};

export type Breakpoint = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
